<template>
  <div class="home page-2 page-4">
    <div class="box">
      <div class="logo"><img src="@/assets/image/logo1.png" /></div>
      <div class="nav">
        <router-link to="/Notice" class="item" v-if="$isPermission('agency_message')">
          <img src="@/assets/image/nav-1.svg" alt="">
          <div class="txt">皇太后公告</div>
        </router-link>
        <router-link to="/Catering" class="item" v-if="$isPermission('agency_meal_manage')">
          <img src="@/assets/image/nav-2.svg" alt="">
          <div class="txt">餐務管理</div>

        </router-link>
        <router-link to="/Meal" class="item" v-if="$isPermission('agency_meal_query')">
          <img src="@/assets/image/nav-3.svg" alt="">
          <div class="txt">餐況查詢</div>
        </router-link>
        <router-link to="/System" class="item" v-if="$isPermission('agency_system')">
          <img src="@/assets/image/nav-4.svg" alt="">
          <div class="txt">管理後台</div>

        </router-link>
<!--        <a href="#" class="item">-->
<!--          <img src="@/assets/image/nav-5.svg" alt="">-->
<!--          <div class="txt">使用說明</div>-->
<!--        </a>-->
      </div>
    </div>
    <a class="page-out" style="cursor: pointer" @click="loginOut">系統登出 <i class="iconfont icon-out"></i></a>
  </div>
</template>

<script>

import { logout } from "@/api";

export default {
  name: "Home",
  data() {
    return {

    }
  },
  created() {

  },
  mounted() {

  },
  methods:{
    checkCapslock(e) {
      const { key } = e
      this.capsTooltip = key && key.length === 1 && (key >= 'A' && key <= 'Z')
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleLogin() {
      console.log(111)
      this.informationVisible = true
    },

    loginOut(){
      logout().then(res =>{
        if(res.code == 200){
          this.$router.push('/login')
          window.localStorage.removeItem('token')
          window.localStorage.removeItem('agency_info')
        }
      })

    }
  }
};
</script>

<style lang="scss" scoped>
.home {

}
</style>
